import { HierarchicalCodeBook } from "../../models";

export interface SchoolCandidateInstitutionSummarySearch{
    countyList?: number[];
    municipalityList?: HierarchicalCodeBook[];
    townList?: HierarchicalCodeBook[];
    institutionId?: number;
    status?: number;
    onlyWithUnsentSchoolCandidates: boolean;
}

export enum SchoolCandidateInstitutionSummarySort {
    County = 1,
    Town,
    Institution,
    SchoolCandidateCount,
    SchoolCandiateSentCount,
    Status,
}

export enum SchoolCandidateSentStatus {
    NotSent = 1,
    PartlySent,
    ConfirmationRequired,
    Sent,
}